import { render, staticRenderFns } from "./Onramp.vue?vue&type=template&id=688e239d&scoped=true&"
import script from "./Onramp.vue?vue&type=script&lang=js&"
export * from "./Onramp.vue?vue&type=script&lang=js&"
import style0 from "./Onramp.vue?vue&type=style&index=0&id=688e239d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e239d",
  null
  
)

export default component.exports